(function ($) {
    const axiosMidiaConfig = {
        headers: {
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
            "ngrok-skip-browser-warning": "true",
        },
    };

    const limparGravacao = function () {
        const audio = document.querySelector(".js-bemmelhor-v2-audio");

        if (!audio) {
            return;
        }

        audio.pause();

        if (audio._bemmelhorObjectUrl) {
            URL.revokeObjectURL(audio._bemmelhorObjectUrl);
            audio._bemmelhorObjectUrl = null;
        }

        audio.removeAttribute("src");
        audio.load();
    };

    const escaparHtml = function (texto) {
        return String(texto || "")
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#39;");
    };

    const rotuloParticipante = function (mensagem, mapaSpeakers) {
        if (mensagem.speaker_name) {
            return mensagem.speaker_name;
        }

        const speaker = String(mensagem.speaker || "0");

        if (!mapaSpeakers[speaker]) {
            mapaSpeakers[speaker] =
                "Participante " + (Object.keys(mapaSpeakers).length + 1);
        }

        return mapaSpeakers[speaker];
    };

    const ladoDaMensagem = function (speaker) {
        return String(speaker) === "0" ? "esquerda" : "direita";
    };

    const renderizarChat = function ($container, mensagens) {
        const mapaSpeakers = {};
        let html = "";

        (mensagens || []).forEach(function (mensagem) {
            if (!mensagem || !mensagem.texto) {
                return;
            }

            const lado = ladoDaMensagem(mensagem.speaker);
            const autor = rotuloParticipante(mensagem, mapaSpeakers);

            html +=
                '<div class="bemmelhor-v2-chat__msg bemmelhor-v2-chat__msg--' +
                lado +
                '">' +
                '<div class="bemmelhor-v2-chat__autor">' +
                escaparHtml(autor) +
                "</div>" +
                '<div class="bemmelhor-v2-chat__balao">' +
                escaparHtml(mensagem.texto) +
                "</div>" +
                "</div>";
        });

        $container.html(html);
    };

    const setEstadoResumo = function ($modal, texto, mensagem) {
        const $conteudo = $modal.find(".js-bemmelhor-v2-resumo-texto");
        const $vazio = $modal.find(".js-bemmelhor-v2-resumo-vazia");

        $conteudo.text(texto || "");
        $vazio.addClass("d-none").text("");

        if (!texto) {
            $vazio.text(mensagem || "Conteúdo indisponível.").removeClass("d-none");
        }
    };

    const setEstadoTranscricao = function ($modal, mensagens, mensagem) {
        const $conteudo = $modal.find(".js-bemmelhor-v2-transcricao-texto");
        const $vazio = $modal.find(".js-bemmelhor-v2-transcricao-vazia");

        $conteudo.empty();
        $vazio.addClass("d-none").text("");

        if (mensagens && mensagens.length) {
            renderizarChat($conteudo, mensagens);
            return;
        }

        $vazio.text(mensagem || "Conteúdo indisponível.").removeClass("d-none");
    };

    const setEstadoCarregandoResumo = function ($modal, mensagem) {
        const $conteudo = $modal.find(".js-bemmelhor-v2-resumo-texto");
        const $vazio = $modal.find(".js-bemmelhor-v2-resumo-vazia");

        $conteudo.text("");
        $vazio.text(mensagem || "Carregando...").removeClass("d-none");
    };

    const setEstadoCarregandoTranscricao = function ($modal, mensagem) {
        const $conteudo = $modal.find(".js-bemmelhor-v2-transcricao-texto");
        const $vazio = $modal.find(".js-bemmelhor-v2-transcricao-vazia");

        $conteudo.empty();
        $vazio.text(mensagem || "Carregando...").removeClass("d-none");
    };

    const buscarMidia = function (url) {
        return window.axios.get(url, axiosMidiaConfig).then(function (response) {
            return response.data || {};
        });
    };

    const mensagemErroBlob = function (blob, fallback) {
        if (!blob || typeof blob.text !== "function") {
            return Promise.resolve(fallback);
        }

        return blob.text().then(function (texto) {
            try {
                const dados = JSON.parse(texto || "{}");

                return (
                    dados.message ||
                    fallback ||
                    "Não foi possível carregar a gravação."
                );
            } catch (e) {
                return fallback || "Não foi possível carregar a gravação.";
            }
        });
    };

    const abrirGravacao = function (chamadaId, midiaUrl) {
        const $modal = $("#modalBemMelhorV2Gravacao");
        const $audio = $modal.find(".js-bemmelhor-v2-audio");
        const $vazio = $modal.find(".js-bemmelhor-v2-gravacao-vazia");
        const audioEl = $audio.get(0);

        limparGravacao();
        $vazio
            .text("Carregando gravação...")
            .removeClass("d-none");
        $modal.modal("show");

        // Carrega o áudio inteiro como blob para o player ter duração e seek.
        window.axios
            .get(midiaUrl, {
                responseType: "blob",
                headers: {
                    Accept: "audio/*,application/json",
                    "X-Requested-With": "XMLHttpRequest",
                    "ngrok-skip-browser-warning": "true",
                },
                validateStatus: function (status) {
                    return status >= 200 && status < 500;
                },
            })
            .then(function (response) {
                const blob = response.data;
                const tipo = String((blob && blob.type) || "").toLowerCase();
                const pareceJson =
                    tipo.indexOf("json") >= 0 || response.status !== 200;

                if (pareceJson) {
                    return mensagemErroBlob(
                        blob,
                        "Não foi possível carregar a gravação."
                    ).then(function (mensagem) {
                        $vazio.text(mensagem).removeClass("d-none");
                    });
                }

                const objectUrl = URL.createObjectURL(blob);
                audioEl._bemmelhorObjectUrl = objectUrl;
                $vazio.addClass("d-none");
                audioEl.setAttribute("src", objectUrl);
                audioEl.load();
            })
            .catch(function (error) {
                const blob =
                    error && error.response ? error.response.data : null;

                return mensagemErroBlob(
                    blob,
                    "Não foi possível carregar a gravação."
                ).then(function (mensagem) {
                    $vazio.text(mensagem).removeClass("d-none");
                });
            });
    };

    const abrirResumo = function (midiaUrl) {
        const $modal = $("#modalBemMelhorV2Resumo");

        setEstadoCarregandoResumo(
            $modal,
            "Buscando resumo (a IA pode demorar alguns minutos)..."
        );
        $modal.modal("show");

        const tentar = function (tentativa) {
            buscarMidia(midiaUrl)
                .then(function (dados) {
                    if (dados.status === "pronto" && dados.texto) {
                        setEstadoResumo($modal, dados.texto, null);
                        return;
                    }

                    if (dados.status === "pendente" && tentativa < 5) {
                        setEstadoCarregandoResumo(
                            $modal,
                            (dados.message ||
                                "Ainda gerando... nova tentativa em alguns segundos.") +
                                " (" +
                                (tentativa + 1) +
                                "/5)"
                        );
                        window.setTimeout(function () {
                            tentar(tentativa + 1);
                        }, 5000);
                        return;
                    }

                    setEstadoResumo(
                        $modal,
                        null,
                        dados.message || "Conteúdo indisponível no momento."
                    );
                })
                .catch(function (error) {
                    const dados =
                        error && error.response && error.response.data
                            ? error.response.data
                            : {};
                    setEstadoResumo(
                        $modal,
                        null,
                        dados.message || "Não foi possível carregar o conteúdo."
                    );
                });
        };

        tentar(0);
    };

    const abrirTranscricao = function (midiaUrl) {
        const $modal = $("#modalBemMelhorV2Transcricao");

        setEstadoCarregandoTranscricao(
            $modal,
            "Buscando transcrição (a IA pode demorar alguns minutos)..."
        );
        $modal.modal("show");

        const tentar = function (tentativa) {
            buscarMidia(midiaUrl)
                .then(function (dados) {
                    const mensagens = dados.mensagens || [];

                    if (
                        dados.status === "pronto" &&
                        (mensagens.length || dados.texto)
                    ) {
                        if (!mensagens.length && dados.texto) {
                            setEstadoTranscricao(
                                $modal,
                                [
                                    {
                                        texto: dados.texto,
                                        speaker: "0",
                                        speaker_name: null,
                                    },
                                ],
                                null
                            );
                            return;
                        }

                        setEstadoTranscricao($modal, mensagens, null);
                        return;
                    }

                    if (dados.status === "pendente" && tentativa < 5) {
                        setEstadoCarregandoTranscricao(
                            $modal,
                            (dados.message ||
                                "Ainda gerando... nova tentativa em alguns segundos.") +
                                " (" +
                                (tentativa + 1) +
                                "/5)"
                        );
                        window.setTimeout(function () {
                            tentar(tentativa + 1);
                        }, 5000);
                        return;
                    }

                    setEstadoTranscricao(
                        $modal,
                        [],
                        dados.message || "Conteúdo indisponível no momento."
                    );
                })
                .catch(function (error) {
                    const dados =
                        error && error.response && error.response.data
                            ? error.response.data
                            : {};
                    setEstadoTranscricao(
                        $modal,
                        [],
                        dados.message || "Não foi possível carregar o conteúdo."
                    );
                });
        };

        tentar(0);
    };

    Eloca.behaviors.bemmelhorV2Midia = function (context) {
        $(".js-bemmelhor-v2-midia", context).on("click", function (event) {
            event.preventDefault();

            const $botao = $(this);
            const tipo = $botao.attr("data-tipo");
            const midiaUrl = $botao.attr("data-midia-url");
            const chamadaId = $botao.attr("data-chamada-id");

            if (!midiaUrl) {
                return;
            }

            if (tipo === "gravacao") {
                abrirGravacao(chamadaId, midiaUrl);
                return;
            }

            if (tipo === "transcricao") {
                abrirTranscricao(midiaUrl);
                return;
            }

            if (tipo === "resumo") {
                abrirResumo(midiaUrl);
            }
        });

        $("#modalBemMelhorV2Gravacao", context)
            .off("hidden.bs.modal.bemmelhorV2Midia")
            .on("hidden.bs.modal.bemmelhorV2Midia", function () {
                limparGravacao();
            });
    };
})(jQuery);
